import { jsxs as l, jsx as e, Fragment as c } from "react/jsx-runtime";
function d(a) {
  try {
    const o = localStorage.getItem(a), s = JSON.parse(o || "{}").lastUpdated;
    return s === void 0 ? /* @__PURE__ */ new Date() : new Date(s);
  } catch {
    return /* @__PURE__ */ new Date();
  }
}
function m(a) {
  const o = /* @__PURE__ */ new Date(), s = o.getDate(), t = o.getDay(), i = new Date(o.setDate(s - t)), n = new Date(i);
  return n.setDate(n.getDate() + 6), a >= i && a <= n;
}
const h = (a) => {
  const o = /* @__PURE__ */ new Date(), s = /* @__PURE__ */ new Date();
  return s.setDate(s.getDate() - 1), a.map((t) => ({
    ...t,
    date: t.lastUpdated ? new Date(t.lastUpdated) : d(t.id)
  })).sort((t, i) => i.date.getTime() - t.date.getTime()).reduce((t, i) => {
    const n = i.date;
    let r = "Today";
    return n.toDateString() === o.toDateString() ? r = "Today" : n.toDateString() === s.toDateString() ? r = "Yesterday" : m(n) ? r = "This Week" : r = `${n.toLocaleString("default", {
      month: "long"
    })} ${n.getFullYear()}`, t[r] || (t[r] = []), t[r].push(i), t;
  }, {});
}, _ = () => {
  const a = window.localStoragSuffix;
  return console.log("::: Suffix: ", a), a && a !== "malayalam" ? a : "";
}, p = ({ config: a }) => {
  var s;
  let o = [];
  try {
    const t = localStorage.getItem(
      "filestore-plugin" + _()
    );
    if (t) {
      const i = JSON.parse(t);
      (s = i == null ? void 0 : i.state) != null && s.files && (o = h(i.state.files), console.log(o));
    }
  } catch (t) {
    console.error("::: Error reading files", t), o = [];
  }
  return /* @__PURE__ */ l("div", { className: "manglish-drawer opacity-50 !hidden lg:!flex", children: [
    /* @__PURE__ */ e("div", { className: "mt-2 text-base flex flex-col justify-center py-5", children: /* @__PURE__ */ l("div", { className: "flex gap-2 items-center ml-6", children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: (a.headerIconClass ?? "manglish-circular-icon") + " w-[32px] h-[32px]"
        }
      ),
      /* @__PURE__ */ e("div", { className: "font-semibold", children: a.headerText })
    ] }) }),
    /* @__PURE__ */ l("div", { id: "filestorage-plugin-mount", className: "flex flex-col h-full", children: [
      /* @__PURE__ */ e("div", { className: "filestore__new-file", children: /* @__PURE__ */ l("div", { className: "flex justify-center items-center", children: [
        /* @__PURE__ */ e("div", { className: "add-icon filestore__new-file__icon" }),
        /* @__PURE__ */ e("div", { children: "New File" })
      ] }) }),
      /* @__PURE__ */ e("div", { className: "flex flex-col flex-grow relative overflow-x-hidden", children: /* @__PURE__ */ e("div", { className: "filestore__files_container", children: Object.keys(o).map((t, i) => /* @__PURE__ */ l("div", { className: "flex flex-col", children: [
        /* @__PURE__ */ e("div", { className: "filestore__item__date", children: t }),
        o[t].map((n, r) => /* @__PURE__ */ l(
          "div",
          {
            className: "filestore__item " + (r == 0 && i == 0 ? "filestore__item--selected" : ""),
            children: [
              /* @__PURE__ */ e("div", { className: "filestore__item__name pr-2", children: n.displayName }),
              /* @__PURE__ */ e("div", { className: "w-0 h-6" })
            ]
          }
        ))
      ] }, i)) }) })
    ] }),
    /* @__PURE__ */ e("div", { className: "manglish-drawer__note", children: "Your files are stored only in this browser" }),
    /* @__PURE__ */ e("div", { className: "manglish-drawer__feedback", children: "Tell us your feedback" }),
    /* @__PURE__ */ e(
      "a",
      {
        href: "https://www.manglish.app/legacy",
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-editorToggleColor text-sm text-center mb-2",
        children: "Switch to old version"
      }
    )
  ] });
};
function v({
  config: a
}) {
  return /* @__PURE__ */ l("div", { className: "bottombar  px-8 py-3", children: [
    /* @__PURE__ */ l("label", { className: "manglish-switch !cursor-not-allowed", children: [
      /* @__PURE__ */ e(
        "input",
        {
          type: "checkbox",
          className: "peer sr-only",
          defaultValue: ""
        }
      ),
      /* @__PURE__ */ l("div", { className: "manglish-switch__toggle", children: [
        /* @__PURE__ */ e("span", { className: "manglish-switch__toggle--text manglish-switch__toggle__ml unselected", children: (a == null ? void 0 : a.languageToggleText) ?? "മലയാളം" }),
        /* @__PURE__ */ e("span", { className: "manglish-switch__toggle--text z-10 w-max ", children: "English" })
      ] })
    ] }),
    /* @__PURE__ */ l("div", { className: "flex items-center gap-1 w-max ml-auto ", children: [
      /* @__PURE__ */ l(
        "div",
        {
          className: "action-button opacity-50 !cursor-not-allowed pointer-events-none  ",
          "aria-label": "Voice Typing",
          children: [
            /* @__PURE__ */ e("div", { className: "mic-icon w-6 h-6 " }),
            /* @__PURE__ */ e("div", { className: "hidden lg:!block", children: "Voice Typing" })
          ]
        }
      ),
      /* @__PURE__ */ l(
        "div",
        {
          className: "action-button opacity-50 !cursor-not-allowed pointer-events-none  ",
          "aria-label": "Copy Text",
          children: [
            /* @__PURE__ */ e("div", { className: "copy-icon w-6 h-6 " }),
            /* @__PURE__ */ e("div", { className: "hidden lg:!block", children: "Copy Text" })
          ]
        }
      )
    ] })
  ] });
}
const N = () => /* @__PURE__ */ l(
  "div",
  {
    className: "toolbar opacity-50",
    id: "clusterdev-toolbar",
    style: { zIndex: 1e3 },
    children: [
      /* @__PURE__ */ l("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ l("div", { className: "flex gap-1", children: [
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item ", children: /* @__PURE__ */ e(
              "div",
              {
                className: "undo-icon toolbar__icon-button",
                "aria-label": "Undo"
              }
            ) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "Undo" })
          ] }),
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item pointer-events-none opacity-50 !cursor-not-allowed", children: /* @__PURE__ */ e(
              "div",
              {
                className: "redo-icon toolbar__icon-button",
                "aria-label": "Redo"
              }
            ) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "Redo" })
          ] })
        ] }),
        /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
          /* @__PURE__ */ l(
            "div",
            {
              id: "toolbar-font-options",
              className: "toolbar__dropdown-button w-[130px]",
              children: [
                /* @__PURE__ */ e(
                  "span",
                  {
                    className: "text-sm mr-2 ml-2",
                    style: { fontFamily: '"Noto Sans Malayalam"' },
                    children: "Default"
                  }
                ),
                /* @__PURE__ */ e("div", { className: "chevron-down-icon toolbar__icon-button" })
              ]
            }
          ),
          /* @__PURE__ */ e("div", { className: "tooltip", children: "Fonts" })
        ] }),
        /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
          /* @__PURE__ */ l(
            "div",
            {
              id: "toolbar-font-sizes",
              className: "toolbar__dropdown-button w-[100px] ml-1",
              children: [
                /* @__PURE__ */ e("div", { className: "minus-icon toolbar__icon-button toolbar__dropdown-button__icon" }),
                /* @__PURE__ */ e("div", { className: "toolbar__font-size-edit", children: "16" }),
                /* @__PURE__ */ e("div", { className: "add-icon toolbar__icon-button toolbar__dropdown-button__icon" })
              ]
            }
          ),
          /* @__PURE__ */ e("div", { className: "tooltip", children: "Font Size" })
        ] }),
        /* @__PURE__ */ l("div", { className: "items-center gap-0.5 sm:gap-1 hidden lg:!flex", children: [
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item ", children: /* @__PURE__ */ e(
              "div",
              {
                className: "bold-icon toolbar__icon-button ",
                "aria-label": "Format Bold"
              }
            ) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "Bold (Ctrl + B)" })
          ] }),
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item ", children: /* @__PURE__ */ e(
              "div",
              {
                className: "italic-icon toolbar__icon-button ",
                "aria-label": "Format Italics"
              }
            ) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "Italic (Ctrl + I)" })
          ] }),
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item ", children: /* @__PURE__ */ e(
              "div",
              {
                className: "underline-icon toolbar__icon-button !mr-0",
                "aria-label": "Format Underline"
              }
            ) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "Underline (Ctrl + U)" })
          ] })
        ] }),
        /* @__PURE__ */ e("div", { className: "toolbar__divider hidden lg:!block" }),
        /* @__PURE__ */ l("div", { className: "flex gap-0.5 sm:gap-1 hidden lg:!flex", children: [
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item ", id: "toolbar-format-menu", children: /* @__PURE__ */ l("div", { className: "flex", children: [
              /* @__PURE__ */ e(
                "div",
                {
                  className: "align-left-dark-icon toolbar__icon-button",
                  "aria-label": "left"
                }
              ),
              /* @__PURE__ */ e(
                "div",
                {
                  className: "arrow-filled-icon toolbar__icon-button",
                  "aria-label": "arrow-filled-icon"
                }
              )
            ] }) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "Align Tools" })
          ] }),
          /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
            /* @__PURE__ */ e("div", { className: "toolbar__item ", id: "toolbar-list-menu", children: /* @__PURE__ */ l("div", { className: "flex", children: [
              /* @__PURE__ */ e("div", { className: "format-bullet-icon  toolbar__icon-button" }),
              /* @__PURE__ */ e(
                "div",
                {
                  className: "arrow-filled-icon toolbar__icon-button",
                  "aria-label": "arrow-filled-icon"
                }
              )
            ] }) }),
            /* @__PURE__ */ e("div", { className: "tooltip", children: "List Tools" })
          ] })
        ] }),
        /* @__PURE__ */ e("div", { className: "toolbar__divider  hidden lg:!block" }),
        /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
          /* @__PURE__ */ e("div", { className: "toolbar__item hidden lg:!flex", children: /* @__PURE__ */ e("div", { className: "print-icon cursor-pointer" }) }),
          /* @__PURE__ */ e("div", { className: "tooltip", children: "Print (Ctrl+P)" })
        ] })
      ] }),
      /* @__PURE__ */ l("div", { className: "tooltip__has-tooltip", children: [
        /* @__PURE__ */ e(
          "div",
          {
            className: "more-icon cursor-pointer hidden lg:!flex",
            "aria-label": "settings",
            id: "toolbar-settings-options"
          }
        ),
        /* @__PURE__ */ e("div", { className: "tooltip", children: "Settings" })
      ] })
    ]
  }
);
function f({ config: a }) {
  return /* @__PURE__ */ e(c, { children: /* @__PURE__ */ l("div", { className: "flex h-full app-container", style: { cursor: "wait" }, children: [
    /* @__PURE__ */ e(p, { config: a }),
    /* @__PURE__ */ l("div", { className: "editor-container", children: [
      /* @__PURE__ */ e(N, {}),
      /* @__PURE__ */ e("div", { className: "editor-inner", children: /* @__PURE__ */ e("div", { className: "editor-input", children: /* @__PURE__ */ e(
        "div",
        {
          className: "editor-loader",
          style: {
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }
        }
      ) }) }),
      /* @__PURE__ */ e(v, { config: a })
    ] }),
    /* @__PURE__ */ e("div", { className: "w-[30px] overflow-x" })
  ] }) });
}
function u({ config: a }) {
  return /* @__PURE__ */ e(c, { children: /* @__PURE__ */ e("div", { className: "Editor-root", children: /* @__PURE__ */ e(f, { config: a }) }) });
}
export {
  u as default
};
//# sourceMappingURL=skeleton.es.js.map
